<template>
  <div class="productDetails">
    <div class="item1">
      <Swi :spuImgs="spuImgs" />
    </div>
    <div class="item2">
      <div class="item2-t1">{{ detailObj.title }}</div>
      <div class="item2-t2">
        <span class="span1 product-details-price">{{ salePriceLabel }}</span>
        <span class="span3"></span>
      </div>
      <!--<div class="item2-t3"><span></span></div>-->
    </div>
    <div class="item3 mt20">
      <span class="item-span1">选择</span>
      <div v-if="specCount == 1">
        <div class="item-class-type">
          <div class="item-class-type-name">
            <span class="item-class-type-label">已选：</span>
            <span class="item-class-type-text">{{ classTypeText }}</span>
          </div>
          <div class="item-class-type-num">共{{ specCount }}个可选项</div>
        </div>
      </div>
      <div v-if="specCount > 1">
        <div class="item-class-type-more">
          <span class="item-class-type-name">
            <span class="item-class-type-label">请选择:</span>
          </span>
          <span class="item-class-type-num">共{{ specCount }}个可选项</span>
        </div>
      </div>
    </div>
    <div class="item4 mt20">
      <div class="item4-li">
        <span class="item4-t1">学历</span>
        <img class="item4-img" src="../assets/img/icon_xueli.png" alt="icon" />
        <span class="item4-t2"
          >{{ $getDegreeCategory(detailObj.degreeCategoryCode) }} -
          {{ detailObj.degreeName }}</span
        >
        <!--<span class="item-info">查看详情</span>
        <img class="item-to" src="../assets/img/right.png" alt="right" />-->
      </div>
      <div class="item4-li">
        <span class="item4-t1">学校</span>
        <img class="item4-img" src="../assets/img/icon_home.png" alt="icon" />
        <span class="item4-t2">{{ detailObj.schoolName }}</span>
      </div>
      <div class="item4-li">
        <span class="item4-t1">专业</span>
        <img
          class="item4-img"
          src="../assets/img/icon_zhuanye.png"
          alt="icon"
        />
        <span class="item4-t2">{{ detailObj.majorName }}</span>
      </div>
    </div>
    <div class="item5 mt20">
      <img class="item5-img" :src="shopIcon" alt="icon" @error="errorImg" />
      <span class="item5-t1">{{ shopName }}</span>
      <!--<img class="item-to" src="../assets/img/right.png" alt="right" />-->
    </div>
    <div class="item6 mt20">
      <div class="item6-t1">详细介绍</div>
      <div class="product-preview-detail">
        <div v-html="detailObj.description"></div>
      </div>
    </div>
    <Down v-if="isShow" />
  </div>
</template>

<script>
// import Swiper from '../components/swiper'
import Swi from '@/components/swiper.vue';
import Down from '@/components/download.vue';
import shopDefault from '../assets/img/icon_user.png';
import { getSpuDetail } from '@/api/spu';
import { fenToYuan } from '@/utils/global';
export default {
  name: 'productDetails',
  components: { Swi, Down },
  data() {
    return {
      isShow: true,
      spuId: '',
      detailPicUrl: '',
      shopIcon: shopDefault,
      styleObj: {
        height: '600px'
      },
      specCount: 0,
      shopName: '', //商家名称
      detailId: '',
      detailObj: {
        spuId: '', //商品id
        title: '', //商品名称
        state: 0, //状态，1-下架，8-售罄，9-上架
        shopCategoryId: '', //商家自定义分类id
        shopCategoryName: '', //商家自定义分类名称
        memo: '', //备注
        editTime: '', //编辑时间
        listTime: '', //上架时间
        totalSales: 0, //总销量
        totalStock: 0, //总库存
        displayPrice: '', //一口价，单位分
        originalPrice: '', //原价，单位分
        contractTemplateId: '', //合同模板id
        degreeCategoryCode: '', //层次主类目编码，1-国开，2-成教，3-自考，4-网教
        degreeName: '', //层次名称，例如高升专、专升本、高升本
        schoolName: '', //学校名称
        majorName: '', //专业名称
        customCode: '', //商家编码
        images: '', //商品轮播图，逗号分隔的oss地址
        description: '', //商品描述信息
        stockMode: 1, //库存扣减模式，1-拍下减库存，2-付款减库存
        skuSpecs: '', //销售属性定义
        skuDetails: [],
        delistTime: '' //下架时间
      },
      classTypeText: '',
      spuImgs: [],
      salePriceLabel: '' // 显示价格
    };
  },
  mounted() {
    this.getRouterData();
    this.getSpuData();
  },
  methods: {
    // 获取路由信息
    getRouterData() {
      let queryObj = this.$route.query;
      if (queryObj != null && queryObj.hasOwnProperty('id')) {
        this.spuId = queryObj.id;
      }
    },
    // 获取班型数据
    getClassTypes() {
      const that = this;
      let reText = '';
      if (that.detailObj.skuSpecs) {
        let specArr = JSON.parse(that.detailObj.skuSpecs)['班型'];
        if (specArr.length > 0) {
          reText = specArr.join(',');
        }
        that.specCount = specArr.length;
      }
      return reText;
    },
    // 图片访问错误时显示默认图标
    errorImg() {
      this.shopIcon = shopDefault;
    },
    // 获取商品信息
    getSpuData() {
      const that = this;
      if (that.spuId) {
        getSpuDetail(that.spuId).then((res) => {
          if (res.s > 0 && res.d != null) {
            let spuD = res.d;
            console.log(spuD);
            that.detailObj = spuD;
            window.document.title = '橙鹿 - ' + spuD.title;
            if (spuD.hasOwnProperty('shopIcon') && spuD.shopIcon) {
              that.shopIcon = spuD.shopIcon;
            }
            if (spuD.hasOwnProperty('shopName') && spuD.shopName) {
              that.shopName = spuD.shopName;
            }
            that.classTypeText = that.getClassTypes();
            if (spuD.images) {
              let imgArr = spuD.images.split(',');
              that.spuImgs = imgArr;
              if (imgArr.length > 0) {
                let covImg = imgArr[0];
                that.detailObj.coverImg = covImg;
              }
            }
            that.getShowPrice(spuD);
          }
        });
      }
    },
    // 获取转换后价格
    transPrice(srcPrice) {
      let rePrice = 0;
      if (srcPrice != undefined && srcPrice != null && srcPrice != '') {
        rePrice = srcPrice;
      }
      return rePrice;
    },
    // 获取显示价格，单个价格或者区间
    getShowPrice(srcData) {
      const that = this;
      let skuModels = srcData.skuDetails;
      if (skuModels != null && skuModels.length > 0) {
        let degreeCategoryCode = srcData.degreeCategoryCode;
        let prices = [];
        if (skuModels != null && skuModels != undefined && skuModels != '') {
          for (let s = 0; s < skuModels.length; s++) {
            let sku = skuModels[s];
            let tmpPrice = 0;
            if (degreeCategoryCode == 3) {
              tmpPrice = that.transPrice(sku.materialFee);
            } else {
              tmpPrice = that.transPrice(sku.tuitionFee);
            }
            prices.push(tmpPrice);
          }
          if (skuModels.length == 1) {
            let minNum = Math.min(...prices);
            let skNum = that.transPrice(minNum);
            that.salePriceLabel = '￥' + fenToYuan(skNum);
          } else if (skuModels.length > 1) {
            let minP = that.transPrice(Math.min(...prices));
            let maxP = that.transPrice(Math.max(...prices));
            if (minP == maxP) {
              that.salePriceLabel = '￥' + fenToYuan(minP);
            } else {
              that.salePriceLabel =
                '￥' + fenToYuan(minP) + '-' + '￥' + fenToYuan(maxP);
            }
          }
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// @import '@/assets/css/color.scss';
.productDetails {
  //  height:100%;
  background-color: #f8f8f8;
  font-size: 24px;
  color: #06112a;
  padding-bottom: 0.3rem;
}
.item1 {
  width: 100%;
}
.item2,
.item3,
.item4,
.item5 {
  background-color: #fff;
  padding: 0 32px;
}
.item2 {
  padding-bottom: 32px;
  border-radius: 0px 0px 24px 24px;
}
.item2-t1 {
  font-size: 36px;
  font-weight: bold;
  color: #06112a;
  line-height: 48px;
  padding-top: 32px;
}
.item2-t2 {
  display: flex;
  color: #8d939c;
  justify-content: flex-start;
  padding-top: 20px;
}
.span1 {
  color: #ff660f;
  font-size: 12pt;
}
.span2 {
  font-size: 22px;
  transform: scale(0.92);
  padding-left: 16px;
}
.span3 {
  font: size 20px;
  transform: scale(0.83);
  margin-left: auto;
}
.item2-t3 {
  height: 10px;
  margin-top: 20px;
  background-color: #e9edf1;
  border-radius: 5px;
}
.item2-t3 span {
  display: block;
  width: 560px;
  height: 10px;
  background-color: #ff660f;
  border-radius: 5px;
}

.mt20 {
  margin-top: 20px;
}
.item3,
.item4,
.item5 {
  border-radius: 24px;
  //    margin-top:20px;
}
.item3 {
  height: 90px;
  display: flex;
  position: relative;
}
.item-span1,
.item-span2,
.item-span3 {
  display: block;
}
.item-span1,
.item-span3 {
  color: #8d939c;
}
.item-span1,
.item-span2 {
  line-height: 90px;
}
.item-span1 {
  width: 112px;
}
.item-span2 {
  width: 93px;
}
.item-span3 {
  width: 176px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  margin-top: 21px;
  background-color: #f8f8f8;
}
.item-to {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 32px;
  top: 50%;
  transform: translateY(-50%);
}
.item-info {
  display: block;
  position: absolute;
  right: 70px;
  top: 50%;
  color: #8d939c;
  transform: translateY(-50%);
}
.item4 {
  position: relative;
  font-size: 28px;
  font-weight: 500;
  padding: 18px 32px;
}
.item4-li {
  display: flex;
  line-height: 60px;
}
.item4-t1 {
  width: 112px;
  color: #8d939c;
}
.item4-t2 {
  padding-left: 12px;
}
.item4-img {
  display: block;
  width: 32px;
  height: 32px;
  margin-top: 12px;
}
.item5 {
  height: 144px;
  display: flex;
  position: relative;
  //    box-sizing:border-box;
}
.item5-img {
  width: 80px;
  height: 80px;
  margin-top: 32px;
}
.item5-t1 {
  font-size: 30px;
  font-weight: bold;
  color: #06112a;
  line-height: 144px;
  padding-left: 20px;
}
.item6 {
  //  margin-top:20px;
  min-height: 228px;
  border-radius: 24px 24px 0 0;
}
.item6-t1 {
  font-size: 30px;
  font-weight: bold;
  color: #06112a;
  text-align: center;
  line-height: 96px;
  background-color: #fff;
}
.item6-img {
  display: block;
  width: 100%;
}
.item-class-type {
  clear: both;
  line-height: 0.6rem !important;
}
.item-class-type-more {
  clear: both;
  line-height: 1.2rem !important;
}
.product-preview-detail {
  min-height: 2rem;
  padding: 0.5rem;
  margin-bottom: 2rem;
  background-color: #fff;
}
.item-class-type-num {
  background: #f8f8f8;
  padding: 0 0.2rem 0 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/view/productDetails.vue